export default __webpack_public_path__ + "static/media/jobTerix-logo-white.b87976d5.svg";